import React from 'react'
import AdsBanner from "./AdsBanner"
import LocalServiceAds from "./LocalServiceAds"
import BenefitsAds from "./BenefitsAds"
const GoogleAds = () => {
  return (
    <>
    <AdsBanner/>
    <LocalServiceAds/>
    <BenefitsAds/>
    </>
  )
}

export default GoogleAds